export const schema = {
  country: {
    required: 'Country is required',
  },
};
